import { Component, Input, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-app-info-modal',
  templateUrl: './app-info-modal.component.html',
  styleUrls: ['./app-info-modal.component.scss'],
  standalone: false
})
export class AppInfoModalComponent {

  @Input() appVersion: string = '1.0.0';

  constructor(private modalController: ModalController, private translate: TranslateService) { }

  async close(): Promise<void> {
    await this.modalController.dismiss(null, 'close');
  }

  async openExternal(url: string): Promise<void> {
    await Browser.open({ url });
  }

  openMail(email: string): void {
    window.location.href = `mailto:${email}`;
  }

  get appInfoText(): string {
    return this.translate
      .instant('APP_INFO_TEXT', { appVersion: this.appVersion })
      .replace(/\n\n/g, '<br><br>')
      .replace(/\n/g, '<br>');
  }

}
